const stripHtml = (html: string) => html.replace(/<[^>]*>/g, "");

export function buildFaqSchema(
  items: { q: string; a: string }[],
  citations?: object[],
): object {
  const schema: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": items.map((item) => ({
      "@type": "Question",
      "name": item.q,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": stripHtml(item.a),
      },
    })),
  };

  if (citations && citations.length > 0) {
    schema["citation"] = citations;
  }

  return schema;
}
